import types from '../types';
import _ from 'lodash';
import moment from 'moment';
import { duckConstants } from '../../../constants';
import { extractState } from '../../../utilities/combineUseReducer';

const reducer = (state, action) => {
  switch (action.type) {
    case types.RESET_DATA: {
      return { lc_email_checked: true };
    }

    case types.EDIT_LCI: {
      return { ...state, ...action.lciData, access_code: action.lciData.lc_interviewer_access_code };
    }

    case types.GET_ALL_CANDIDATES_FOR_EDIT_LCI: {
      return { ...state, addedCandidates: [], candidatesForEditLCI: false };
    }

    case types.GET_ALL_CANDIDATES_FOR_EDIT_LCI_SUCCESS: {
      return { ...state, addedCandidates: [], candidatesForEditLCI: action.result };
    }

    case types.GET_ALL_CANDIDATES_FOR_EDIT_LCI_ERROR: {
      return { ...state, addedCandidates: [], candidatesForEditLCI: false };
    }

    case types.GET_LCI_CANDIDATE_INFO_SUCCESS: {
      if (state.candidatesForEditLCI) {
        return { ...state, addedCandidates: action.result, candidatesForEditLCI: false };
      }
      return state;
    }

    case types.GET_LCI_CANDIDATE_INFO_ERROR: {
      return { ...state, candidatesForEditLCI: false };
    }

    case types.SET_DISPLAY_TITLE: {
      return { ...state, lc_display_title: action.title };
    }

    case types.SET_INTERVIEW_DATE: {
      return { ...state, lc_date: action.date };
    }

    case types.SET_INTERVIEW_TIME: {
      let interviewDate = state.lc_date;
      if (interviewDate) {
        interviewDate = moment(interviewDate).set(action.time);
      } else {
        interviewDate = moment().set(action.time);
      }

      return { ...state, lc_date: interviewDate.format() };
    }

    case types.SET_INTERVIEW_DURATION: {
      return { ...state, lc_duration: action.duration };
    }

    case types.SET_INTERVIEWER: {
      return { ...state, lc_interviewer: action.lc_interviewer };
    }

    case types.SET_CODE_CHALLENGE: {
      return { ...state, lc_code_challenge: action.lc_code_challenge };
    }

    case types.ADD_CANDIDATE_TO_LCI: {
      if (state.addedCandidates) {
        const index = _.findIndex(state.addedCandidates, { id: action.id });
        if (index !== -1) return state;
      }

      if (state.addedCandidates && Array.isArray(state.addedCandidates)) state.addedCandidates.push({ id: action.id, kind: 'ADD' });
      else state.addedCandidates = [{ id: action.id, kind: 'ADD' }];

      return { ...state };
    }

    case types.SET_EMAIL_CHECK: {
      return { ...state, lc_email_checked: action.lc_email_checked };
    }

    /* TO UPDATE THE CURRENT access_code AFTER THE CREATE LCI ACTION SUCCESS */
    /* lc_id, access_code AND participantAccessCodes SCATTERED IN DIFFERENT COMPONENTS, SO ADD THE CASE HERE FOR ALL-IN-ONE */
    /* THE DISPATCH ACTION WILL RUN THROUGH EVERY REDUCERS */
    case types.CREATE_LCI_SUCCESS: {
      const { lc_id, access_code, participantAccessCodes } = action.result;
      if (participantAccessCodes && Array.isArray(participantAccessCodes)) {
        participantAccessCodes.map(codeInfo => {
          if (state.addedCandidates && Array.isArray(state.addedCandidates)) {
            const index = _.findIndex(state.addedCandidates, { id: codeInfo.id });
            if (index !== -1) {
              state.addedCandidates[index].access_code = codeInfo.access_code;
            }
          }
        });
      }

      return { ...state, access_code, id: lc_id };
    }

    case types.UPDATE_LCI_SUCCESS: {
      const { participantAccessCodes } = action.result;
      if (participantAccessCodes && Array.isArray(participantAccessCodes)) {
        participantAccessCodes.map(codeInfo => {
          if (state.addedCandidates && Array.isArray(state.addedCandidates)) {
            const index = _.findIndex(state.addedCandidates, { id: codeInfo.id });
            if (index !== -1) {
              state.addedCandidates[index].access_code = codeInfo.access_code;
            }
          }
        });
      }

      return { ...state };
    }

    /* START LCI */
    case types.START_LCI: {
      return { ...state, lc_interviewer_access_code: action.lc_interviewer_access_code };
    }

    case types.REHYDRATE: {
      /* INITIAL STATE */
      const initialState = (state && state[stateKey]) ? { ...state[stateKey] } : extractState(duckConstants.LCI_SETUP_ROOT, stateKey);
      return { ...state, ...initialState };
    }

    default:
      return state;
  }
};

const stateKey = 'lciData';

export default { reducer, stateKey };
